<div [formGroup]="parentFormGroup" class="form-container">
  <mat-form-field appearance="outline" class="form-date">
    <mat-label i18n>Booking window closes</mat-label>
    <input matInput [matDatepicker]="bookingWindowClose" id="booking-window-close-date" formControlName="closeDate">
    <mat-datepicker-toggle matSuffix [for]="bookingWindowClose"></mat-datepicker-toggle>
    <mat-datepicker [startAt]="startAt" #bookingWindowClose></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="outline" class="form-hour">
    <mat-label i18n>Hour</mat-label>
    <mat-select id="booking-window-close-hour" formControlName="closeHour">
      @for (option of hourNames; track option) {
        <mat-option [value]="option.id">
          {{ option.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="form-minute">
    <mat-label i18n>Minute</mat-label>
    <mat-select id="booking-window-close-minute" formControlName="closeMinute">
      @for (option of minuteNames; track option) {
        <mat-option [value]="option.id">
          {{ option.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
